export default __webpack_public_path__ + "3f9adc3eb4832762c35c4193d15b8825.woff2";